import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { removeMilestoneError } from "@planzone/dto";

const initialState: State = [];

function handleRequest(
  state: State,
  milestone: Boundaries["removeMilestone"]["request"],
): State {
  return [
    ...state,
    {
      milestone,
      request: setRequestStateToPending(),
      error: removeMilestoneError,
    },
  ];
}

function handleSuccess(
  state: State,
  milestone: Boundaries["removeMilestone"]["success"],
): State {
  return state.map((item) =>
    item.milestone.uuid === milestone.uuid
      ? {
          milestone,
          request: setRequestStateToSuccess(),
          error: removeMilestoneError,
        }
      : item,
  );
}

function handleFailure(
  state: State,
  { milestone, error }: Boundaries["removeMilestone"]["failure"],
): State {
  return state.map((item) =>
    item.milestone.uuid === milestone.uuid
      ? { milestone, request: setRequestStateToFailure(), error }
      : item,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeMilestoneRequested]: handleRequest,
    [events.removeMilestoneSucceeded]: handleSuccess,
    [events.removeMilestoneFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
